export default {
  selectedService: null,
  boxCalculateBy: null,
  boxWeight: null,
  boxVolume: {
    height: null,
    width: null,
    length: null,
    boxesAmount: null,
    totalVolume: null,
  },
  totalPallets: null,
  looseOption: null,
  materialDimentions: {
    length: null,
    weight: null,
  },
  transportOption: null,
};
